import { render, staticRenderFns } from "./BaseBlockEditor.vue?vue&type=template&id=70eabda2&scoped=true&"
import script from "./BaseBlockEditor.vue?vue&type=script&lang=js&"
export * from "./BaseBlockEditor.vue?vue&type=script&lang=js&"
import style0 from "./BaseBlockEditor.vue?vue&type=style&index=0&id=70eabda2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70eabda2",
  null
  
)

export default component.exports